import React from 'react'

const JitsiMeet = ({ lection }) => {
  return (
    <div className="lecture-content">
      <div className="lecture-container">
        <div className="row">
          <div className="col-12">
            <div className="embedded-content">
              <iframe
                src={lection.content.url}
                allow="camera; microphone; fullscreen; display-capture; autoplay"
                width="100%"
                height="650px"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default JitsiMeet
